import { clampNumber } from "./clamp-number";

function getClampedSkipTimeSeconds(
  currentTimeSeconds: number,
  offsetSeconds: number,
  durationSeconds?: number,
): number | undefined {
  if (!Number.isFinite(currentTimeSeconds) || !Number.isFinite(offsetSeconds)) {
    return undefined;
  }

  const maximum = durationSeconds ?? currentTimeSeconds;

  if (!Number.isFinite(maximum)) {
    return undefined;
  }

  return clampNumber(currentTimeSeconds + offsetSeconds, 0, maximum);
}

export { getClampedSkipTimeSeconds };
